module.exports = __webpack_public_path__ + "img/rexel.673836cd.png";